import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ProductLimitCellProps } from "./types";

export const ProductLimitCell = ({ 
  userId, 
  subscriptionPlan, 
  currentLimit,
  onUpdateLimit 
}: ProductLimitCellProps) => {
  const [editingLimit, setEditingLimit] = useState<number | null>(null);

  const handleSave = async () => {
    if (editingLimit !== null) {
      await onUpdateLimit(userId, editingLimit);
      setEditingLimit(null);
    }
  };

  if (editingLimit !== null) {
    return (
      <div className="flex items-center gap-2">
        <Input
          type="number"
          value={editingLimit}
          onChange={(e) => setEditingLimit(parseInt(e.target.value))}
          className="w-20"
        />
        <Button
          variant="outline"
          size="sm"
          onClick={handleSave}
        >
          Valider
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setEditingLimit(null)}
        >
          Annuler
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span>{currentLimit === -1 ? "Illimité" : currentLimit}</span>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setEditingLimit(currentLimit === -1 ? 3 : currentLimit)}
      >
        Modifier
      </Button>
    </div>
  );
};